$(function () {
  //popular-destinations slider
  $(".js-popular-destinations").owlCarousel({
    loop: false,
    margin: 8,
    rtl: true,
    responsiveClass: true,
    autoWidth: false,
    dots: true,
    responsive: {
      0: {
        items: 2,
        autoWidth: true,
      },
      768: {
        items: 4,
        autoWidth: false,
      },
      1320: {
        items: 5,
        nav: true,
        margin: 24,
      },
    },
  });

  //-four-columns slider
  $(".js-four-columns").owlCarousel({
    loop: false,
    margin: 8,
    rtl: true,
    responsiveClass: true,
    autoWidth: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
      },
      768: {
        items: 2,
        margin: 20,
        autoWidth: false,
      },
      1180: {
        items: 3,
        nav: true,
        margin: 24,
      },
    },
  });

  //tour-slider slider
  $(".js-tour-slider").owlCarousel({
    loop: false,
    margin: 8,
    rtl: true,
    responsiveClass: true,
    autoWidth: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
      },
      768: {
        items: 2,
        autoWidth: false,
        margin: 20,
      },
      1180: {
        items: 3,
        nav: true,
        margin: 24,
      },
    },
  });

  //close newsletters
  $(".js-newsletters-close").click(function () {
    $(this).closest(".js-newsletters").remove();
  });
});
